module.exports = __webpack_public_path__ + "img/avatar4.f40f3a43.jpg";